<template>
  <el-container class="main-layout">
    <!-- 顶部标题栏 -->
    <el-header class="header">
      <div class="header-content">
        <h1></h1>

        <div class="user-info" v-if="isLoggedIn">
          <el-button type="text" size="medium"  style="color:#111" @click="handleContactUs">关于我们</el-button>

<!--          <el-button type="text" size="medium"  style="color:#111" @click="openSunoVerifyCode">获取验证码</el-button>-->

          <el-button type="text" size="medium"  style="color:#111" @click="openRechargeCarMi">提取账号</el-button>

          <el-button type="text" size="medium" @click="openRechargeDialog">充值</el-button>

          <img
              src="@/assets/icon/refresh.svg"
              class="refresh-icon"
              @click="refreshPackage"
              alt="刷新"
          />

          <el-dropdown @command="handleUserCommand">
            <span class="el-dropdown-link">
              <img src="@/assets/icon/avatar-login.svg" class="avatar-icon" alt="用户头像" />
              {{userInfo ? userInfo.phone : '' }} <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu>
              <el-dropdown-item>
                用户ID: {{ userInfo ? userInfo.userId : '' }}
                <img
                    style="margin-left: 10px; cursor: pointer"
                    src="@/assets/icon/copy.svg"
                    class="refresh-icon"
                    alt="复制"
                    @click.stop="copyUserId"
                />
              </el-dropdown-item>

              <el-dropdown-item>
                流量剩余: {{ userInfo ? userInfo.remainTraffic : '' }}
                <el-button
                    style="padding-left: 10px"
                    type="text"
                    size="medium"
                    @click="openRechargeDialog"
                >充值</el-button>
              </el-dropdown-item>

              <el-dropdown-item command="orders">我的订单</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div v-else>
          <img src="@/assets/icon/avatar-unlogin.svg" class="avatar-icon" alt="用户头像" />
          <el-button type="text" @click="openLoginDialog">登录</el-button>
        </div>
      </div>
    </el-header>

    <el-container>

      <!-- 主内容区 -->
      <el-main>
        <!-- 子页面只需 this.$emit('show-login-dialog') 即可触发 -->
        <div :class="['content', { 'no-scroll': noScroll }]">
          <router-view @show-login-dialog="openLoginDialog" />
        </div>
      </el-main>
    </el-container>

    <!-- 充值对话框 -->
    <RechargeDialog
        ref="rechargeDialog"
        :recharge-packages="rechargePackages"
        :recharge-form="rechargeForm"
        @close="handleRechargeDialogClose"
        @confirm-recharge="confirmRecharge"
        @fetch-user-info="fetchUserInfo"
        width="50%"
    />

    <!-- 关于我们对话框 -->
    <el-dialog :visible.sync="contactDialogVisible" title="关于我们" width="55%">
      <div style="text-align: center">
        <div style="display:flex;justify-content:center;gap:50px;margin-bottom:20px;">
<!--          <div>-->
<!--            <img-->
<!--                src="https://oss.suno.ti-mi.cn/ti-mi.cn/music/icon/kf.png"-->
<!--                alt="售前客服二维码"-->
<!--                style="width:200px;height:200px"-->
<!--            />-->
<!--            <p style="margin-top:10px;font-size:16px;color:#606266">扫码咨询客服</p>-->
<!--            <p style="margin-top:5px;font-size:14px;color:#606266">购买账号 /售后保障 /技术支持</p>-->
<!--          </div>-->
          <div>
            <img
                src="https://oss.suno.ti-mi.cn/togo/image/kf2.png"
                alt="售后客服二维码"
                style="width:200px;height:200px"
            />
            <p style="margin-top:10px;font-size:16px;color:#606266">扫码添加微信客服</p>
            <p style="margin-top:5px;font-size:14px;color:#606266">购买账号 /售后保障 /技术支持</p>
          </div>
        </div>
      </div>
      <div>
        <p>Suno导航是由哈勃团队潜心研发的AI导航</p>
        <p>
          基于全球顶尖的AI大模型技术深度研发，无梯无墙，即可访问国外正版的SUNO官网；
          为每个用户创造完全隔离的浏览器，确保您能够流畅的安全的纯净的使用原滋原味的正版网站。
        </p>
      </div>
    </el-dialog>

    <!-- 我的订单对话框 -->
    <el-dialog :visible.sync="ordersDialogVisible" title="我的订单" width="75%">
      <Orders />
    </el-dialog>

    <!-- 登录弹窗（只保留这一种） -->
    <login-dialog
        v-if="loginDialogVisible"
        @close="closeLoginDialog"
        @login-success="handleLoginSuccess"
    />

    <!-- 卡密对话 -->
    <el-dialog :visible.sync="rechargeWizardVisible"
               custom-class="notice-dialog"
               :show-header="false"
               :show-close="false"
               title=""
               :top="'5%'"
               width="50%">
      <RechargeWizard ref="rechargeWizard"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeRechargeCarMi">关闭</el-button>
      </span>
    </el-dialog>

    <!-- suno验证码 -->
    <el-dialog :visible.sync="sunoVerifyCodeVisible"
               custom-class="notice-dialog"
               :show-header="false"
               :show-close="false"
               title=""
               :top="'5%'"
               width="60%">
      <SunoVerifyCode ref="sunoVerifyCode" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSunoVerifyCode">关闭</el-button>
      </span>
    </el-dialog>


  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import RechargeDialog from "./RechargeDialog.vue";
import Orders from "./Orders.vue";
import { userApi } from "@/utils/api";
import LoginDialog from "./Login.vue";
import RechargeWizard from "@/components/RechargeWizard.vue";
import SunoVerifyCode from "@/components/SunoVerifyCode.vue";
import { rechargeClosedMessage } from "@/utils/shutdown";

export default {
  name: "MainLayout",
  components: {
    RechargeWizard,
    LoginDialog,
    RechargeDialog,
    Orders,
    SunoVerifyCode,
  },
  computed: {
    ...mapState(["isLoggedIn"]), // 从 Vuex 获取 isLoggedIn 状态
    userPhone() {
      // 从本地存储获取手机号
      return localStorage.getItem("userPhone") || "";
    },
    // 首页禁滚动的判断：优先 meta.noScroll，其次路由名/路径兜底
    noScroll() {
      const r = this.$route || {};
      if (r.meta && r.meta.noScroll === true) return true;
      return r.name === 'SunoHome' || r.path === '/suno';
    }
  },
  data() {
    return {
      sunoVerifyCodeVisible: false,
      rechargeWizardVisible: false,
      contactDialogVisible: false,
      ordersDialogVisible: false,
      loginDialogVisible: false, // 控制登录对话框显示
      userInfo: null, // 新增用户信息
      rechargePackages: [
        {
          id: 1,
          name: "套餐A",
          discountPrice: "¥50",
          originalPrice: "¥100",
          data: 10,
          validity: "30天",
        },
        {
          id: 2,
          name: "套餐B",
          discountPrice: "¥90",
          originalPrice: "¥150",
          data: 20,
          validity: "60天",
        },
      ],
      rechargeForm: {
        package: null,
        paymentMethod: "支付宝",
      },
    };
  },
  async created() {
    // 只有在用户已登录时才获取用户信息
    if (this.isLoggedIn) {
      await this.fetchUserInfo();
    }
  },
  watch: {
    // 监听登录状态变化
    isLoggedIn(newVal) {
      if (newVal) {
        // 用户刚登录时获取用户信息
        this.fetchUserInfo();
      } else {
        // 用户退出登录时清除用户信息
        this.userInfo = null;
      }
    },
  },
  methods: {
    ...mapMutations(["setLoggedIn"]), // Vuex mutation，用于更新登录状态
    // 获取用户信息
    async fetchUserInfo() {
      try {
        const response = await userApi.getUserInfo();
        this.userInfo = response.data;
      } catch (error) {
        this.$message.error("获取用户信息失败: " + error.message);
      }
    },
    handleUserCommand(command) {
      if (command === "logout") {
        // 更新全局登录状态
        this.setLoggedIn(false);
        // 清除本地存储
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("userPhone"); // 清除用户手机号
        // 更新 Vuex 状态（假设存在 setUserPhone mutation）
        this.$store.commit("setUserPhone", "");
        // 清除用户信息
        this.userInfo = null;
      } else if (command === "orders") {
        this.ordersDialogVisible = true;
      }
    },
    handleContactUs() {
      this.contactDialogVisible = true;
    },
    refreshPackage() {
      // 刷新整个页面
      window.location.reload();
    },
    confirmRecharge() {
      console.log("确认充值", this.rechargeForm);
    },
    goToLogin() {
      this.loginDialogVisible = true; // 显示登录对话框
    },
    // 停止运营：充值功能已关闭
    openRechargeDialog() {
      this.showRechargeClosed();
    },
    showRechargeClosed() {
      this.$alert(rechargeClosedMessage(), "功能已关闭", {
        confirmButtonText: "我知道了",
        type: "warning",
      }).catch(() => {});
    },
    handleRechargeDialogClose() {
      // 可以在这里处理充值对话框关闭的逻辑
    },
    /* 登录弹窗控制（统一入口） */
    openLoginDialog() {
      this.loginDialogVisible = true
    },
    closeLoginDialog() {
      this.loginDialogVisible = false
    },
    // 处理登录成功事件
    handleLoginSuccess() {
      this.loginDialogVisible = false;
    },
    copyUserId() {
      const userId = this.userInfo.userId;
      if (navigator.clipboard) {
        navigator.clipboard
            .writeText(userId)
            .then(() => {
              this.$message.success("用户ID已复制到剪贴板");
            })
            .catch((err) => {
              this.$message.error("复制失败: " + err);
            });
      } else {
        // 兼容性处理
        const textArea = document.createElement("textarea");
        textArea.value = userId;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const successful = document.execCommand("copy");
          if (successful) {
            this.$message.success("用户ID已复制到剪贴板");
          } else {
            this.$message.error("复制失败");
          }
        } catch (err) {
          this.$message.error("复制失败: " + err);
        }
        document.body.removeChild(textArea);
      }
    },
    // 停止运营：提取账号功能已关闭
    openRechargeCarMi() {
      this.showRechargeClosed();
    },
    closeRechargeCarMi() {
      const accountInfo = this.$refs.rechargeWizard.accountInfo;
      if (accountInfo !== '') {
        this.$confirm(
            "请妥善保管账号信息，离开页面后无法再次查看，确定关闭吗",
            "",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
        ).then(() => {
          this.$refs.rechargeWizard.reset();
          this.rechargeWizardVisible = false;
        }).catch(() => {
        });
      } else {
        this.$refs.rechargeWizard.reset();
        this.rechargeWizardVisible = false;
      }
    }
    ,
    closeSunoVerifyCode() {
      this.$refs.sunoVerifyCode.reset()
      this.sunoVerifyCodeVisible = false;
    }
    ,
    openSunoVerifyCode() {
      this.sunoVerifyCodeVisible = true;
    },
  },
  mounted() {
    console.log("isLoggedIn:", this.isLoggedIn); // 调试 Vuex 状态
  },
};
</script>

<style scoped>

.main-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header {
  background-color: #ffffff; /* 将背景色改为白色 */
  color: #333333; /* 修改字体颜色为深灰色以提高可读性 */
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 保持阴影效果 */
  position: relative; /* 添加相对定位以便添加渐变线条 */
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #303133;
  letter-spacing: 1px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.remaining-package {
  font-size: 16px;
  color: #606266;
  font-weight: 500;
}

.remaining-count {
  color: #67c23a;
  font-weight: 600;
  font-size: 17px;
}

.refresh-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: transform 0.3s;
  vertical-align: middle;
}

.refresh-icon:hover {
  transform: rotate(90deg);
}

.user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 15px;
  color: #606266;
  font-weight: 500;
}

.el-dropdown-link {
  font-size: 15px;
  color: #000;
  font-weight: 500;
}

.avatar-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
}

.sidebar-menu .el-menu-item {
  font-size: 16px;
  color: #606266;
  font-weight: 500;
}

.sidebar-menu .el-menu-item:hover {
  color: #409eff;
}

.sidebar-menu .el-menu-item.is-active {
  color: #409eff;
  font-weight: 600;
}

.container {
  display: flex;
  flex: 1;
  overflow-y: auto; /* 添加垂直滚动条 */
  scrollbar-width: thin;
}

.sidebar {
  background-color: #f5f5f5;
  border-right: 1px solid #eaeaea;
}

.sidebar-menu {
  height: 100%;
  border: none;
}

.content {
  flex: 1;
  background-color: #f5f5f5;
  padding: 20px;
  overflow-y: auto;
  scrollbar-width: thin;
}

/* 关键：内容区成为弹性容器的“自适应部分” */
.content{
  flex:1 1 auto;
  min-height:0;    /* 防止子元素 100% 高度把父容器再撑出滚动条 */
  overflow:auto;   /* 默认其它页面可以滚动 */
}

/* 首页（SunoHome）不滚动，滚动条消失 */
.content.no-scroll{
  overflow:hidden;
}

</style>
